var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row" }, [
      _c("div", { staticClass: "content-header-left col-md-9 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v(
                _vm._s(_vm.trans("tax_payer.tax_payer")) +
                  "\n                        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/tax-payer" } }, [
                      _vm._v(_vm._s(_vm.trans("tax_payer.tax_payers")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.user.profile
                  ? _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v(
                        _vm._s(
                          _vm.user.profile.first_name +
                            " " +
                            _vm.user.profile.last_name
                        ) +
                          " (" +
                          _vm._s(_vm.user.email) +
                          ")"
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        },
        [
          _c("div", { staticClass: "form-group breadcrum-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm pull-right",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/tax-payer")
                  }
                }
              },
              [
                _c("i", { staticClass: "feather icon-list" }),
                _vm._v(" " + _vm._s(_vm.trans("tax_payer.tax_payer_list")))
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c(
        "div",
        { attrs: { id: "user-profile" } },
        [
          _c("user-sidebar", { attrs: { menu: "basic", id: _vm.id } }),
          _vm._v(" "),
          _c("section", { attrs: { id: "profile-info" } }, [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("user-summary", { attrs: { user: _vm.user } }),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-8 col-12" }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(_vm.trans("user.basic")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-start align-items-center mb-1"
                          },
                          [
                            _c(
                              "form",
                              {
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.submit.apply(null, arguments)
                                  },
                                  keydown: function($event) {
                                    return _vm.userForm.errors.clear(
                                      $event.target.name
                                    )
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-sm-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-12 col-sm-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.trans(
                                                            "user.first_name"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.userForm
                                                            .first_name,
                                                        expression:
                                                          "userForm.first_name"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.userForm.errors.has(
                                                        "first_name"
                                                      )
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      value: "",
                                                      name: "first_name",
                                                      placeholder: _vm.trans(
                                                        "user.first_name"
                                                      )
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.userForm.first_name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.userForm,
                                                          "first_name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("show-error", {
                                                    attrs: {
                                                      "form-name": _vm.userForm,
                                                      "prop-name": "first_name"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-12 col-sm-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.trans(
                                                            "user.last_name"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.userForm
                                                            .last_name,
                                                        expression:
                                                          "userForm.last_name"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.userForm.errors.has(
                                                        "last_name"
                                                      )
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      value: "",
                                                      name: "last_name",
                                                      placeholder: _vm.trans(
                                                        "user.last_name"
                                                      )
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.userForm.last_name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.userForm,
                                                          "last_name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("show-error", {
                                                    attrs: {
                                                      "form-name": _vm.userForm,
                                                      "prop-name": "last_name"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-12 col-sm-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.trans(
                                                            "user.email"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.userForm.email,
                                                        expression:
                                                          "userForm.email"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.userForm.errors.has(
                                                        "email"
                                                      )
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      value: "",
                                                      name: "email",
                                                      placeholder: _vm.trans(
                                                        "user.email"
                                                      ),
                                                      readonly: ""
                                                    },
                                                    domProps: {
                                                      value: _vm.userForm.email
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.userForm,
                                                          "email",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("show-error", {
                                                    attrs: {
                                                      "form-name": _vm.userForm,
                                                      "prop-name": "email"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-12 col-sm-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.trans(
                                                            "user.gender"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(_vm.genders, function(
                                                    gender
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "radio radio-info"
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.userForm
                                                                  .gender,
                                                              expression:
                                                                "userForm.gender"
                                                            }
                                                          ],
                                                          class: {
                                                            "is-invalid": _vm.userForm.errors.has(
                                                              "gender"
                                                            )
                                                          },
                                                          attrs: {
                                                            type: "radio",
                                                            id: gender.id,
                                                            name: "gender"
                                                          },
                                                          domProps: {
                                                            value: gender.id,
                                                            checked:
                                                              _vm.userForm
                                                                .gender ==
                                                              gender.id,
                                                            checked: _vm._q(
                                                              _vm.userForm
                                                                .gender,
                                                              gender.id
                                                            )
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.userForm,
                                                                "gender",
                                                                gender.id
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for: gender.id
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.trans(
                                                                    "list." +
                                                                      gender.id
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c("show-error", {
                                                    attrs: {
                                                      "form-name": _vm.userForm,
                                                      "prop-name": "gender"
                                                    }
                                                  })
                                                ],
                                                2
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.userHasRole(_vm.user, "admin")
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 col-sm-6"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: { for: "" }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.trans(
                                                                  "role.role"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("v-select", {
                                                          class: {
                                                            "is-invalid": _vm.userForm.errors.has(
                                                              "role_id"
                                                            )
                                                          },
                                                          attrs: {
                                                            label: "name",
                                                            "track-by": "id",
                                                            name: "role_id",
                                                            id: "role_id",
                                                            options: _vm.roles,
                                                            placeholder: _vm.trans(
                                                              "role.select_role"
                                                            ),
                                                            multiple: true,
                                                            "close-on-select": false,
                                                            "clear-on-select": false,
                                                            "hide-selected": true,
                                                            selected:
                                                              _vm.selected_roles
                                                          },
                                                          on: {
                                                            select:
                                                              _vm.onRoleSelect,
                                                            remove:
                                                              _vm.onRoleRemove
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.selected_roles,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.selected_roles = $$v
                                                            },
                                                            expression:
                                                              "selected_roles"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("show-error", {
                                                          attrs: {
                                                            "form-name":
                                                              _vm.userForm,
                                                            "prop-name":
                                                              "role_id"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-12 col-sm-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.trans(
                                                            "user.date_of_birth"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("datepicker", {
                                                    class: {
                                                      "is-invalid": _vm.userForm.errors.has(
                                                        "date_of_birth"
                                                      )
                                                    },
                                                    attrs: {
                                                      bootstrapStyling: true,
                                                      name: "date_of_birth"
                                                    },
                                                    on: {
                                                      selected: function(
                                                        $event
                                                      ) {
                                                        return _vm.userForm.errors.clear(
                                                          "date_of_birth"
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.userForm
                                                          .date_of_birth,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.userForm,
                                                          "date_of_birth",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "userForm.date_of_birth"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("show-error", {
                                                    attrs: {
                                                      "form-name": _vm.userForm,
                                                      "prop-name":
                                                        "date_of_birth"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-12 col-sm-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.trans(
                                                            "user.date_of_anniversary"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("datepicker", {
                                                    class: {
                                                      "is-invalid": _vm.userForm.errors.has(
                                                        "date_of_anniversary"
                                                      )
                                                    },
                                                    attrs: {
                                                      bootstrapStyling: true,
                                                      name:
                                                        "date_of_anniversary"
                                                    },
                                                    on: {
                                                      selected: function(
                                                        $event
                                                      ) {
                                                        return _vm.userForm.errors.clear(
                                                          "date_of_anniversary"
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.userForm
                                                          .date_of_anniversary,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.userForm,
                                                          "date_of_anniversary",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "userForm.date_of_anniversary"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("show-error", {
                                                    attrs: {
                                                      "form-name": _vm.userForm,
                                                      "prop-name":
                                                        "date_of_anniversary"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v(_vm._s(_vm.trans("general.save")))]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              ],
              1
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("a", { attrs: { href: "/" } }, [_vm._v("Home")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }